import React, { Ref } from "react";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Grid, GridColumnProps } from "@progress/kendo-react-grid";
import { DataResult } from "@progress/kendo-data-query";
import { tableColumns } from "./tableColumns";

const cellDataTypeForField = (field?: string) => {
  return tableColumns.find((column) => column.field === field)
    ?.exportCellFormat;
};

const exportBrokerDataToExcel = (
  data: DataResult,
  exportObject: ExcelExport,
  columns: GridColumnProps[]
) => {
  const exportColumns = columns.map((column) => {
    const columnWidth = Math.max((column.width as number) || 0, 85);
    const cellOptions = {
      format: cellDataTypeForField(column.field),
    };
    return (
      <ExcelExportColumn
        field={column.field}
        title={column.title}
        cellOptions={cellOptions}
        width={columnWidth}
      />
    );
  });

  exportObject.save(data, exportColumns);
};

export default exportBrokerDataToExcel;
